import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'artificiallly.accordions';

function readMap() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return parsed;
  } catch {
    return {};
  }
}

export function accordionKey(kind, projectId, id) {
  return `${kind}:${projectId}:${id}`;
}

export function readAccordionOpen(key) {
  if (!key) return false;
  return readMap()[key] === true;
}

export function writeAccordionOpen(key, open) {
  if (!key) return;
  try {
    const map = readMap();
    if (open) map[key] = true;
    else delete map[key];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* private mode or a full store */
  }
}

export function useAccordionOpen(key) {
  const [open, setOpenState] = useState(() => readAccordionOpen(key));

  useEffect(() => {
    setOpenState(readAccordionOpen(key));
  }, [key]);

  const setOpen = useCallback((next) => {
    setOpenState((current) => {
      const resolved = typeof next === 'function' ? Boolean(next(current)) : Boolean(next);
      writeAccordionOpen(key, resolved);
      return resolved;
    });
  }, [key]);

  return [open, setOpen];
}
